var styles = {
  "Panel": "pb-Panel__Panel",
  "fullHeight": "pb-Panel__fullHeight",
  "default": "pb-Panel__default",
  "jade": "pb-Panel__jade",
  "slate": "pb-Panel__slate",
  "charcoal": "pb-Panel__charcoal",
  "silver-border": "pb-Panel__silver-border",
  "jade-border": "pb-Panel__jade-border",
  "scarlet-border": "pb-Panel__scarlet-border",
  "information": "pb-Panel__information",
  "error": "pb-Panel__error",
  "success": "pb-Panel__success",
  "warning": "pb-Panel__warning",
  "collapseOnSmallViewport": "pb-Panel__collapseOnSmallViewport"
};
export default styles;